/* Info component on the  Callsheets page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";
import { useCurrentUser } from '../../../contexts/CurrentUserContext';

const InfoCallsheets = () => {
  const currentUser = useCurrentUser();
  return (
    <div>
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
        <h5 className={`text-center pb-2 ${styles.Red }`} >CALLSHEEETS INFO</h5>
        <hr className={`mt-2 mb-0`}/>
        {/* Superadmin */}
        {currentUser &&
                currentUser?.groups.length > 0 &&
                (currentUser?.groups[0]?.name === "Superadmin") ? (
                    <div>  
                    <p>GENERAL INFO
                    </p>
                    <p className="pt-2"><span className={`${styles.Red}`}>*</span> Callsheets display below but 
                    may only be at a <span className={`${styles.Red}`}>preliminary</span> stage so Calltimes will not be accurate.
                    </p>
                    <p className="pt-2"><span className={`${styles.Red}`}>*</span> When a Callsheet for the following Shoot 
                    Day is finalised an email will be sent with a <span className={`${styles.Red}`}>link</span> to that Callsheet.
                    </p>
                    <p className='pt-5'>CREATE / EDIT INFO
                    </p>
                    <p className="pt-2"><span className={`${styles.Red}`}>*</span> Callsheets are initially <span className={`${styles.Red}`}>created</span> on 
                        their Schedule Shoot Day page using the "Create Callsheet" button.
                    </p>
                    <p className="pt-2"><span className={`${styles.Red}`}>*</span> Callsheets may be created for upcoming 
                     Shoot Days and have some basic info added if desired. 
                    </p>
                    <p className="pt-2"><span className={`${styles.Red}`}>*</span> Use the<span className={`${styles.Red}`}> Edit</span> button 
                    on the Callsheet to add and edit Callsheet Info including Crew, Cast and BG Calltimes.
                    </p>
                    <p className="pt-2">
                    <span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Nearest 
                      Hospital</span> is selected from a Dropdown. Use the Hospitals tab on this 
                      page to add them to the Dropdown.
                    </p>
                    <p className="pt-2">
                    <span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Walkies Channels</span> are set here from the 
                    Walkies tab and automatially added to all callsheets.
                    </p>
                    <p className='mt-2'><span className={`${styles.Red}`}>*</span> If the shoot involves multiple countries, and therefore 
                      multiple Units, the Main Unit Schedules and Callsheets are to be used as normal with the relevant 
                        city inputted in the Callsheet's <span className={`${styles.Red}`}>Other Country Units</span> field. The local Crew Calltimes are to be 
                        handled by the local Production Manager who should be Registered on the App.
                    </p>
                    <p className="pt-2"><span className={`${styles.Red}`}>*</span> Callsheets and Calltimes should be<span className={`${styles.Red}`}> Finalised and Sent</span> the day
                    before their Shoot Day.
                    </p>
                    </div>
                  ) : (
                    <div>  
                    <p className="pt-2"><span className={`${styles.Red}`}>*</span> Callsheets display below but 
                    may only be at a preliminary stage so Calltimes will not be accurate.
                    </p>
                    <p className="pt-2"><span className={`${styles.Red}`}>*</span> When a Callsheet for the following Shoot 
                    Day is finalised an email will be sent with a <span className={`${styles.Red}`}>link</span> to that Callsheet.
                    </p>
                </div>
            )}
            <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoCallsheets